import { type CartCalculateResult } from '@hooks-api/types/dataModel/coupon'
import { type CartItem, type FastpassOrderItemBySkuMap } from '../types'

export const parserFastpassOrderItemBySkuMap = (orderItems?: CartCalculateResult['order_items']) => {
  if (!orderItems) return {}
  const orderItemsWithoutSpecificAddon = orderItems.filter(item => !item.addon_main_product_id)
  return orderItemsWithoutSpecificAddon.reduce<FastpassOrderItemBySkuMap>((acc, item) => {
    if (item.sku) {
      acc[item.sku] = {
        sale_price: item.sale_price ?? 0,
        applied_coupon_ids: item.applied_coupon_ids ?? [],
        addon_v2_price: item.addon_v2_price ?? 0,
      }
    }
    else {
      console.error('[parserFastpassOrderItemBySkuMap] item sku is missing', item)
    }
    return acc
  }, {})
}

export const parserCouponCartItemBySkuMap = (orderItems?: CartCalculateResult['order_items'], couponCartItems?: CartItem[]) => {
  if (!orderItems && !couponCartItems) return {}

  if (orderItems) {
    return parserFastpassOrderItemBySkuMap(orderItems)
  }
  else {
    return couponCartItems?.reduce<FastpassOrderItemBySkuMap>((acc, item) => {
      if (item.sku) {
        acc[item.sku] = {
          sale_price: item.sale_price ?? 0,
          addon_v2_price: item.addon_v2_price ?? 0,
        }
      }
      else {
        console.error('[parserCouponCartItemBySkuMap] couponCartItem sku is missing', item)
      }
      return acc
    }, {})
  }
}
